import {
  useEffect,
  useState
} from "react";

import {
  Download,
  Share,
  PlusSquare,
  Smartphone,
  CheckCircle2
} from "lucide-react";


function esStandalone() {

  return (
    window.matchMedia(
      "(display-mode: standalone)"
    ).matches ||
    window.navigator.standalone === true
  );

}


function esIOS() {

  return (
    /iPad|iPhone|iPod/.test(
      navigator.userAgent
    ) ||
    (
      navigator.platform === "MacIntel" &&
      navigator.maxTouchPoints > 1
    )
  );

}


function esAndroid() {

  return /Android/i.test(
    navigator.userAgent
  );

}


export default function InstallVexaDent() {

  const [
    instalada,
    setInstalada
  ] = useState(
    esStandalone()
  );

  const [
    installPrompt,
    setInstallPrompt
  ] = useState(null);

  const [
    ios,
    setIos
  ] = useState(false);

  const [
    android,
    setAndroid
  ] = useState(false);


  useEffect(() => {

    setIos(
      esIOS()
    );

    setAndroid(
      esAndroid()
    );


    const revisarInstalacion = () => {

      if (esStandalone()) {

        setInstalada(true);

      }

    };


    const recibirPrompt = event => {

      event.preventDefault();

      setInstallPrompt(event);

    };


    window.addEventListener(
      "beforeinstallprompt",
      recibirPrompt
    );


    window.addEventListener(
      "appinstalled",
      revisarInstalacion
    );


    return () => {

      window.removeEventListener(
        "beforeinstallprompt",
        recibirPrompt
      );

      window.removeEventListener(
        "appinstalled",
        revisarInstalacion
      );

    };

  }, []);


  const instalarAndroid = async () => {

    if (!installPrompt) {

      return;

    }


    installPrompt.prompt();


    const resultado =
      await installPrompt.userChoice;


    if (
      resultado?.outcome ===
      "accepted"
    ) {

      setInstallPrompt(null);

    }

  };


  if (instalada) {

    return null;

  }


  return (

    <div
      className="vd-install-screen"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999999,
        background: "#f8fafc",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding:
          "24px 18px calc(24px + env(safe-area-inset-bottom))",
        fontFamily:
          "Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
        overflowY: "auto"
      }}
    >

      <div
        className="vd-install-card"
        style={{
          width: "100%",
          maxWidth: 430,
          background: "#ffffff",
          borderRadius: 28,
          padding: "32px 24px",
          boxShadow:
            "0 20px 60px rgba(15,23,42,.12)",
          textAlign: "center"
        }}
      >

        <div
          style={{
            width: 78,
            height: 78,
            margin: "0 auto 20px",
            borderRadius: 22,
            background: "#2563eb",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow:
              "0 12px 30px rgba(37,99,235,.28)"
          }}
        >

          <Smartphone
            size={38}
            color="#ffffff"
            strokeWidth={2.2}
          />

        </div>


        <div
          style={{
            fontSize: 28,
            fontWeight: 800,
            color: "#0f172a",
            marginBottom: 8
          }}
        >
          Instala VexaDent
        </div>


        <div
          style={{
            fontSize: 15,
            lineHeight: 1.6,
            color: "#64748b",
            marginBottom: 28
          }}
        >
          Para utilizar VexaDent en tu
          dispositivo móvil debes instalar
          la aplicación.
        </div>


        {ios && (

          <div
            style={{
              textAlign: "left"
            }}
          >

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 18
              }}
            >

              <div
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 10,
                  background: "#eff6ff",
                  color: "#2563eb",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                }}
              >
                <Share size={18} />
              </div>

              <div
                style={{
                  fontSize: 14,
                  color: "#334155",
                  lineHeight: 1.4
                }}
              >
                Toca el botón
                <strong> Compartir</strong>
                {" "}de Safari.
              </div>

            </div>


            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 18
              }}
            >

              <div
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 10,
                  background: "#eff6ff",
                  color: "#2563eb",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                }}
              >
                <PlusSquare size={18} />
              </div>

              <div
                style={{
                  fontSize: 14,
                  color: "#334155",
                  lineHeight: 1.4
                }}
              >
                Selecciona
                <strong> Agregar a pantalla de inicio</strong>.
              </div>

            </div>


            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10
              }}
            >

              <div
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 10,
                  background: "#ecfdf5",
                  color: "#16a34a",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                }}
              >
                <CheckCircle2 size={18} />
              </div>

              <div
                style={{
                  fontSize: 14,
                  color: "#334155",
                  lineHeight: 1.4
                }}
              >
                Confirma tocando
                <strong> Agregar</strong>.
              </div>

            </div>

          </div>

        )}


        {android && (

          <div>

            {installPrompt ? (

              <button
                type="button"
                onClick={instalarAndroid}
                style={{
                  width: "100%",
                  border: "none",
                  borderRadius: 16,
                  padding: "16px 18px",
                  background: "#2563eb",
                  color: "#ffffff",
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                  boxShadow:
                    "0 10px 24px rgba(37,99,235,.25)"
                }}
              >

                <Download size={20} />

                Instalar VexaDent

              </button>

            ) : (

              <div
                style={{
                  padding: 18,
                  borderRadius: 16,
                  background: "#eff6ff",
                  color: "#1e3a8a",
                  fontSize: 14,
                  lineHeight: 1.6
                }}
              >

                Abre el menú de tu navegador
                y selecciona
                <strong> Instalar aplicación </strong>
                o
                <strong> Agregar a pantalla de inicio</strong>.

              </div>

            )}

          </div>

        )}


        {!ios && !android && (

          <div
            style={{
              padding: 18,
              borderRadius: 16,
              background: "#eff6ff",
              color: "#1e3a8a",
              fontSize: 14,
              lineHeight: 1.6
            }}
          >

            Instala VexaDent desde el menú
            de tu navegador utilizando la
            opción para agregar la aplicación
            a la pantalla de inicio.

          </div>

        )}


        <div
          style={{
            marginTop: 28,
            paddingTop: 20,
            borderTop:
              "1px solid #e2e8f0",
            fontSize: 12,
            color: "#94a3b8",
            lineHeight: 1.5
          }}
        >

          Una vez instalada, abre VexaDent
          desde su icono para acceder al
          sistema.

        </div>

      </div>

    </div>

  );

}
